/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Api de autenticação dos selos
 * API para autenticação dos selos
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetQueries200Item,
  GetQueriesById200,
  GetQueriesById404One,
  GetQueriesById404Three,
  GetQueriesById404Two,
  GetQueriesParams,
  PatchQueriesByIdStatus200,
  PatchQueriesByIdStatus404One,
  PatchQueriesByIdStatus404Three,
  PatchQueriesByIdStatus404Two,
  PatchQueriesByIdStatusBodyOne,
  PatchQueriesByIdStatusBodyThree,
  PatchQueriesByIdStatusBodyTwo,
  PostQueriesByIdEntry200,
  PostQueriesByIdEntryBody,
  PostQueriesFromHash200,
  PostQueriesFromHashBodyOne,
  PostQueriesFromHashBodyThree,
  PostQueriesFromHashBodyTwo,
  PostQueriesFromPhoto200,
  PostQueriesFromPhotoBody
} from '.././models';

import { apiInstance } from '../../lib/axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getQueriesById = (
    id: string,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<GetQueriesById200>(
      {url: `/queries/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetQueriesByIdQueryKey = (id?: string,) => {
    return [
    `/queries/${id}`
    ] as const;
    }

    
export const getGetQueriesByIdQueryOptions = <TData = Awaited<ReturnType<typeof getQueriesById>>, TError = GetQueriesById404One | GetQueriesById404Two | GetQueriesById404Three>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueriesById>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueriesByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQueriesById>>> = ({ signal }) => getQueriesById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQueriesById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQueriesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQueriesById>>>
export type GetQueriesByIdQueryError = GetQueriesById404One | GetQueriesById404Two | GetQueriesById404Three



export function useGetQueriesById<TData = Awaited<ReturnType<typeof getQueriesById>>, TError = GetQueriesById404One | GetQueriesById404Two | GetQueriesById404Three>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueriesById>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQueriesByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQueries = (
    params: GetQueriesParams,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<GetQueries200Item[]>(
      {url: `/queries`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetQueriesQueryKey = (params?: GetQueriesParams,) => {
    return [
    `/queries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQueriesQueryOptions = <TData = Awaited<ReturnType<typeof getQueries>>, TError = unknown>(params: GetQueriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueries>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQueries>>> = ({ signal }) => getQueries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQueries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQueriesQueryResult = NonNullable<Awaited<ReturnType<typeof getQueries>>>
export type GetQueriesQueryError = unknown



export function useGetQueries<TData = Awaited<ReturnType<typeof getQueries>>, TError = unknown>(
 params: GetQueriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueries>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postQueriesFromHash = (
    postQueriesFromHashBody: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<PostQueriesFromHash200>(
      {url: `/queries/from-hash`, method: 'POST',
      data: postQueriesFromHashBody, signal
    },
      options);
    }
  


export const getPostQueriesFromHashMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromHash>>, TError,{data: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromHash>>, TError,{data: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree}, TContext> => {

const mutationKey = ['postQueriesFromHash'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQueriesFromHash>>, {data: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree}> = (props) => {
          const {data} = props ?? {};

          return  postQueriesFromHash(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQueriesFromHashMutationResult = NonNullable<Awaited<ReturnType<typeof postQueriesFromHash>>>
    export type PostQueriesFromHashMutationBody = PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree
    export type PostQueriesFromHashMutationError = unknown

    export const usePostQueriesFromHash = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromHash>>, TError,{data: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree}, TContext>, request?: SecondParameter<typeof apiInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQueriesFromHash>>,
        TError,
        {data: PostQueriesFromHashBodyOne | PostQueriesFromHashBodyTwo | PostQueriesFromHashBodyThree},
        TContext
      > => {

      const mutationOptions = getPostQueriesFromHashMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postQueriesFromPhoto = (
    postQueriesFromPhotoBody: PostQueriesFromPhotoBody,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`image`, postQueriesFromPhotoBody.image)
formData.append(`latitude`, postQueriesFromPhotoBody.latitude.toString())
formData.append(`longitude`, postQueriesFromPhotoBody.longitude.toString())
if(postQueriesFromPhotoBody.qrcodeContent !== undefined) {
 formData.append(`qrcodeContent`, postQueriesFromPhotoBody.qrcodeContent)
 }

      return apiInstance<PostQueriesFromPhoto200>(
      {url: `/queries/from-photo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostQueriesFromPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromPhoto>>, TError,{data: PostQueriesFromPhotoBody}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromPhoto>>, TError,{data: PostQueriesFromPhotoBody}, TContext> => {

const mutationKey = ['postQueriesFromPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQueriesFromPhoto>>, {data: PostQueriesFromPhotoBody}> = (props) => {
          const {data} = props ?? {};

          return  postQueriesFromPhoto(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQueriesFromPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof postQueriesFromPhoto>>>
    export type PostQueriesFromPhotoMutationBody = PostQueriesFromPhotoBody
    export type PostQueriesFromPhotoMutationError = unknown

    export const usePostQueriesFromPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesFromPhoto>>, TError,{data: PostQueriesFromPhotoBody}, TContext>, request?: SecondParameter<typeof apiInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQueriesFromPhoto>>,
        TError,
        {data: PostQueriesFromPhotoBody},
        TContext
      > => {

      const mutationOptions = getPostQueriesFromPhotoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getQueriesByIdAnalyze = (
    id: string,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      
      return apiInstance<void>(
      {url: `/queries/${id}/analyze`, method: 'GET', signal
    },
      options);
    }
  



export const getGetQueriesByIdAnalyzeQueryKey = (id?: string,) => {
    return [
    `/queries/${id}/analyze`
    ] as const;
    }

    
export const getGetQueriesByIdAnalyzeQueryOptions = <TData = Awaited<ReturnType<typeof getQueriesByIdAnalyze>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueriesByIdAnalyze>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueriesByIdAnalyzeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQueriesByIdAnalyze>>> = ({ signal }) => getQueriesByIdAnalyze(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQueriesByIdAnalyze>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQueriesByIdAnalyzeQueryResult = NonNullable<Awaited<ReturnType<typeof getQueriesByIdAnalyze>>>
export type GetQueriesByIdAnalyzeQueryError = unknown



export function useGetQueriesByIdAnalyze<TData = Awaited<ReturnType<typeof getQueriesByIdAnalyze>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQueriesByIdAnalyze>>, TError, TData>, request?: SecondParameter<typeof apiInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQueriesByIdAnalyzeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postQueriesByIdEntry = (
    id: string,
    postQueriesByIdEntryBody: PostQueriesByIdEntryBody,
 options?: SecondParameter<typeof apiInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`image`, postQueriesByIdEntryBody.image)

      return apiInstance<PostQueriesByIdEntry200>(
      {url: `/queries/${id}/entry`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostQueriesByIdEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesByIdEntry>>, TError,{id: string;data: PostQueriesByIdEntryBody}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postQueriesByIdEntry>>, TError,{id: string;data: PostQueriesByIdEntryBody}, TContext> => {

const mutationKey = ['postQueriesByIdEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQueriesByIdEntry>>, {id: string;data: PostQueriesByIdEntryBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postQueriesByIdEntry(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQueriesByIdEntryMutationResult = NonNullable<Awaited<ReturnType<typeof postQueriesByIdEntry>>>
    export type PostQueriesByIdEntryMutationBody = PostQueriesByIdEntryBody
    export type PostQueriesByIdEntryMutationError = unknown

    export const usePostQueriesByIdEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQueriesByIdEntry>>, TError,{id: string;data: PostQueriesByIdEntryBody}, TContext>, request?: SecondParameter<typeof apiInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQueriesByIdEntry>>,
        TError,
        {id: string;data: PostQueriesByIdEntryBody},
        TContext
      > => {

      const mutationOptions = getPostQueriesByIdEntryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const patchQueriesByIdStatus = (
    id: string,
    patchQueriesByIdStatusBody: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree,
 options?: SecondParameter<typeof apiInstance>,) => {
      
      
      return apiInstance<PatchQueriesByIdStatus200>(
      {url: `/queries/${id}/status`, method: 'PATCH',
      data: patchQueriesByIdStatusBody
    },
      options);
    }
  


export const getPatchQueriesByIdStatusMutationOptions = <TError = PatchQueriesByIdStatus404One | PatchQueriesByIdStatus404Two | PatchQueriesByIdStatus404Three,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQueriesByIdStatus>>, TError,{id: string;data: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree}, TContext>, request?: SecondParameter<typeof apiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchQueriesByIdStatus>>, TError,{id: string;data: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree}, TContext> => {

const mutationKey = ['patchQueriesByIdStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQueriesByIdStatus>>, {id: string;data: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree}> = (props) => {
          const {id,data} = props ?? {};

          return  patchQueriesByIdStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQueriesByIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof patchQueriesByIdStatus>>>
    export type PatchQueriesByIdStatusMutationBody = PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree
    export type PatchQueriesByIdStatusMutationError = PatchQueriesByIdStatus404One | PatchQueriesByIdStatus404Two | PatchQueriesByIdStatus404Three

    export const usePatchQueriesByIdStatus = <TError = PatchQueriesByIdStatus404One | PatchQueriesByIdStatus404Two | PatchQueriesByIdStatus404Three,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQueriesByIdStatus>>, TError,{id: string;data: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree}, TContext>, request?: SecondParameter<typeof apiInstance>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQueriesByIdStatus>>,
        TError,
        {id: string;data: PatchQueriesByIdStatusBodyOne | PatchQueriesByIdStatusBodyTwo | PatchQueriesByIdStatusBodyThree},
        TContext
      > => {

      const mutationOptions = getPatchQueriesByIdStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    